module.exports = __webpack_public_path__ + "static/media/footer-logo.2a6bb706.svg";